import { Button } from 'antd';

import { isRTL, onChangeLanguage } from 'core/services/language';
import { useDispatch } from 'react-redux';
import { changeLanguage } from 'stores/useLanguageStore';

interface InputProps {
	size?: 'small' | 'middle' | 'large';
}

function LanguageButton({ size = 'large' }: InputProps) {
	const dispatch = useDispatch();

	const changeLanguageHandler = () => {
		onChangeLanguage();
		dispatch(changeLanguage());
	};

	return (
		<Button style={{ fontSize: 16 }} onClick={changeLanguageHandler} color="primary" variant="filled" size={size}>
			{isRTL() ? 'English' : 'العربية'}
		</Button>
	);
}

export default LanguageButton;
